import React from 'react';
import { Card, Note, SegmentedControl, Sym } from '../../../components/app2';
import { useTheme } from '../../../components/app2/ThemeContext';
import { THEME_OPTIONS } from '../../../components/app2/theme';

/**
 * Preferencias de la cuenta (rediseño jul-2026).
 *
 * Por ahora hay UNA preferencia real: el tema de la interfaz. El diseño también
 * dibuja preferencias de notificaciones (correo al llegar un recibo, resumen
 * semanal…), pero no existe ni el campo donde guardarlas ni el envío que las
 * respetaría, así que no se incluyen: prometerlas sería mentir.
 *
 * El tema se guarda en el navegador y se comparte con el sitio público, así que
 * la elección viaja entre la landing y la app.
 */

const OPCION_TEXTO = {
  light: 'Siempre claro.',
  auto: 'Sigue la configuración de tu sistema: claro de día, oscuro de noche si así lo tienes.',
  dark: 'Siempre oscuro.',
};

const PreferencesSection = () => {
  const { mode, setMode } = useTheme();

  return (
    <Card>
      <h3 className="a2-card-title" style={{ fontSize: '1.1rem' }}>Preferencias</h3>
      <p className="a2-card-sub" style={{ marginBottom: 20 }}>
        Cómo se ve PaySlip en este dispositivo
      </p>

      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
          <span
            style={{
              width: 38, height: 38, borderRadius: 11, flexShrink: 0,
              background: 'var(--brand-soft)', border: '1px solid var(--brand-line)',
              color: 'var(--brand-2)', display: 'grid', placeItems: 'center',
            }}
          >
            <Sym name="contrast" size={20} />
          </span>
          <div style={{ minWidth: 0 }}>
            <div style={{ font: "700 .98rem 'Hanken Grotesk'", color: 'var(--heading)' }}>
              Tema de la interfaz
            </div>
            <div style={{ font: "500 .84rem 'Hanken Grotesk'", color: 'var(--muted)' }}>
              Claro, automático u oscuro
            </div>
          </div>
        </div>

        <SegmentedControl
          items={THEME_OPTIONS}
          value={mode}
          onChange={setMode}
          role="group"
          aria-label="Tema de la interfaz"
          style={{ marginLeft: 'auto' }}
        />
      </div>

      <Note tone="info" style={{ marginTop: 18 }}>
        {OPCION_TEXTO[mode] || OPCION_TEXTO.auto} La preferencia se guarda en este navegador y
        también aplica al sitio público de PaySlip.
      </Note>
    </Card>
  );
};

export default PreferencesSection;
